module.exports = __webpack_public_path__ + "img/img10.7de7ee4c.png";